import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Discount {
  formatted_amount: string;
  percentage: number;
}

export interface Plan {
  batch_symbol: null;
  braintree_id: string;
  currency: string;
  currency_symbol: string;
  discounted_plan_price: number;
  discounts: {
    total_discount?: Discount;
    default_discount?: Discount;
  };
  billing_cycle_in_months: number;
  formatted_discounted_monthly_price: string;
  formatted_discounted_weekly_price?: string;
  formatted_discounted_price: string;
  formatted_monthly_price: string;
  formatted_weekly_price?: string;
  formatted_price: string;
  formatted_promo_discount_amount: string;
  formatted_regular_monthly_price: string;
  formatted_regular_weekly_price?: string;
  formatted_regular_price: string;
  gross_price?: string;
  has_trial: true;
  is_vip: false;
  ltv: number;
  lv: number;
  merchant_account: string;
  plan_price: number;
  price: number;
  promo_discount_amount: number;
  regular_price: number;
  sales_tax_amount: number;
  starter_fee: number;
  trial_fee: number;
  noom_plan_id: string;
  trial_duration: number;
  payment_source?: "BRAINTREE" | "STRIPE";
  duration_in_months?: number;
  curriculum?: string;
}

export type PlansState = Record<string, Plan>;

const plansSlice = createSlice({
  name: "plans",
  initialState: {} as PlansState,
  reducers: {
    updatePlans(state, action: PayloadAction<PlansState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { updatePlans } = plansSlice.actions;

export default plansSlice.reducer;
